<template>
  <white-block
    class="bulk-details-table-wrapper"
    :class="{ 'bulk-details-table-wrapper--with-padding': withPadding }"
    bordered
  >
    <slot />
  </white-block>
</template>

<script setup lang="ts">
import WhiteBlock from '@/components/shared/templates/WhiteBlock.vue'

defineProps<{
  withPadding?: boolean
}>()
</script>

<style scoped lang="scss">
.bulk-details-table-wrapper {
  & > *:not(:first-child) {
    border-top: 1px solid $border-color;
  }
  &--with-padding {
    padding: 6px 20px;

    @include media-sm-x-max {
      padding: 4px 16px;
    }
  }
}
</style>
